<template>
  <div 
    class="BcApprovalApproverApprovalDescription flex flex-row items-center justify-center w-auto text-right gap-1 text-sm"
    :class="{
      'text-bc-blue': approver.approved,
      'text-bc-red': approver.disapproved,
      'text-gray-400': !approver.approved && !approver.disapproved,
    }"
  >
    <div class="flex flex-col items-end justify-end">
      <span v-if="approver.approved">
        {{ formatDate(approver.approved, 'd. m. y') }}
      </span>
      <span v-else-if="approver.disapproved">
        {{ formatDate(approver.disapproved, 'd. m. y') }}
      </span>
      <span v-else-if="approver.approval_send">
        {{ $t('Waiting for approval from %date% at %time%', {date: formatDate(approver.approval_send, 'd. m. y'), time: formatDate(approver.approval_send, 'H:i')}) }}
      </span>
      <span v-else>
        {{ $t('Publish document to send approval request to user') }}
      </span>
      <template v-if="!approver.approved && !approver.disapproved && approver.last">
        <span 
          v-if="approver.last.approved"
          class="text-xs text-bc-blue"
        >
          {{ $t('Approved %date% at %time% in revision %revision%', {date: formatDate(approver.last.approved, 'd. m. y'), time: formatDate(approver.last.approved, 'H:i'), revision: approver.last.revision}) }}
        </span>
        <span 
          v-else-if="approver.last.disapproved"
          class="text-xs text-bc-red"
        >
          {{ $t('Disapproved %date% at %time% in revision %revision%', {date: formatDate(approver.last.disapproved, 'd. m. y'), time: formatDate(approver.last.disapproved, 'H:i'), revision: approver.last.revision}) }}
        </span>
      </template>
    </div>
    <aw-icon 
      :icon="approvalIcon"
      class="w-5 h-5"
    />
  </div>
</template>

<script>
export default {
  props: {
    approver: {
      type: Object,
      default: null,
    },
  },
  computed: {
    approvalIcon() {
      if (this.approver.approved) {
        return 'check'
      } else if (this.approver.disapproved) {
        return 'close'
      }
      return 'question-simple'
    }
  }
}
</script>

<style lang="scss" scoped>
.BcApprovalApproverApprovalDescription {
  svg {
    min-width: 1.25rem;
  }
}
</style>
